module.exports = __webpack_public_path__ + "img/history_icon.039b588b.svg";